module.exports = __webpack_public_path__ + "static/media/lily_i_wen_su_2.0d04230a.jpg";